import React from 'react';

const TaskManager = ({ windows, onCloseWindow }) => {
  // Map window keys to process names
  const processNames = {
    about: 'About_Me.txt',
    projects: 'Projects.exe',
    terminal: 'Terminal.exe',
    cyberchef: 'SwissArmy.exe',
    taskmanager: 'TaskManager.exe'
  };

  // Get list of currently open windows
  const openProcesses = Object.entries(windows)
    .filter(([key, isOpen]) => isOpen && key !== 'taskmanager')
    .map(([key]) => ({
      key,
      name: processNames[key] || `${key}.exe`,
      memory: Math.floor(Math.random() * 50 + 10) + ' MB', // Random memory for demo
      cpu: Math.floor(Math.random() * 30) + '%' // Random CPU for demo
    }));

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      fontFamily: '"JetBrains Mono", "SF Mono", "Monaco", monospace',
      fontSize: '13px',
      color: '#cbd5e1'
    }}>
      {/* Header */}
      <div style={{
        padding: '10px 15px',
        background: 'rgba(59, 130, 246, 0.1)',
        borderBottom: '1px solid rgba(96, 165, 250, 0.2)',
        fontWeight: '600',
        color: '#60a5fa'
      }}>
        Task Manager - Processes ({openProcesses.length} running)
      </div>

      {/* Table Header */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 80px',
        gap: '10px',
        padding: '10px 15px',
        background: 'rgba(30, 41, 59, 0.5)',
        borderBottom: '1px solid rgba(96, 165, 250, 0.2)',
        fontWeight: '600',
        fontSize: '11px',
        color: '#94a3b8'
      }}>
        <div>Process Name</div>
        <div>Memory</div>
        <div>CPU</div>
        <div>Action</div>
      </div>

      {/* Process List */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '5px 0'
      }}>
        {openProcesses.length === 0 ? (
          <div style={{
            padding: '40px 20px',
            textAlign: 'center',
            color: 'rgba(203, 213, 225, 0.5)',
            fontSize: '12px'
          }}>
            No processes running
          </div>
        ) : (
          openProcesses.map((process) => (
            <div
              key={process.key}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr 80px',
                gap: '10px',
                padding: '8px 15px',
                borderBottom: '1px solid rgba(96, 165, 250, 0.05)',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(96, 165, 250, 0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <div style={{ color: '#cbd5e1' }}>{process.name}</div>
              <div style={{ color: '#94a3b8' }}>{process.memory}</div>
              <div style={{ color: '#94a3b8' }}>{process.cpu}</div>
              <div>
                <button
                  onClick={() => onCloseWindow(process.key)}
                  style={{
                    padding: '4px 12px',
                    fontSize: '11px',
                    borderRadius: '4px',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                    background: 'rgba(239, 68, 68, 0.1)',
                    color: '#ef4444',
                    cursor: 'pointer',
                    fontWeight: '600',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                    e.target.style.boxShadow = '0 0 8px rgba(239, 68, 68, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(239, 68, 68, 0.1)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  End
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div style={{
        padding: '8px 15px',
        background: 'rgba(30, 41, 59, 0.5)',
        borderTop: '1px solid rgba(96, 165, 250, 0.2)',
        fontSize: '11px',
        color: 'rgba(203, 213, 225, 0.7)',
        display: 'flex',
        justifyContent: 'space-between'
      }}>
        <span>Total Processes: {openProcesses.length}</span>
        <span>System: Diptanshu's OS</span>
      </div>
    </div>
  );
};

export default TaskManager;
